import React, { useEffect, useState } from "react";
import NormalInput from "component/common/NormalInput";
import ErrorMessage from "component/common/ErrroMessage";
import { useForm } from "react-hook-form";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import usePopup from "hooks/usePopUp";

import styles from "./AddDispute.module.scss";
import { Toast } from "utils/toast";
import Popup from "component/common/Popup/Popup";
import AddButton from "component/common/AddButton";
import { checkSellerUsingID } from "service/Payment";
import close_icon from "../../../assets/images/close_icon.png";
import { debounce } from "debounce";
import { addDispute, getDisputeById, updateDispute } from "service/Disputed";
import moment from "moment";
import { getRoleAction } from "utils/helper";

const AddDispute = ({
  getDisputed,
  showModal,
  showModalData,
  editModal,
  viewPage,
  id,
  setEditModal,
}) => {
  const { successPopUp } = usePopup();
  const { isOperationAvailable } = getRoleAction("Dispute");
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
    clearErrors,
  } = useForm();

  const showModalFunc = () => {
    showModalData(true);
  };

  const handleCancel = () => {
    showModalData(false);
    setEditModal(false);
    resetFormDetails();
  };

  const [upiProduct, setUpiProduct] = useState({
    UPICode: "",
  });

  const [validation, setValidation] = useState("");

  const [upiProductList, setUpiProductList] = useState({
    UPICodeList: [],
    bankDetails: {},
  });

  useEffect(() => {
    if (editModal && showModal) {
      getSellerDetails();
    }
  }, [showModal]);

  useEffect(() => {
    resetFormDetails();
  }, []);

  //Validating seller id
  const validateSellerUsingAPI = async (id) => {
    let response = await checkSellerUsingID(id?.value);
    if (response?.data?.message === "Seller already exist") {
      Toast({
        type: "error",
        message: response?.data?.message,
      });
    }
    setValidation(response?.data?.message);
  };
  // get seller
  const getSellerDetails = async () => {
    if (id) {
      try {
        let response = await getDisputeById(id);
        if (response.status == 200) {
          const {
            UPICode,
            total_amount,
            note_for_issue,
            buyerName,
            buyerInstaHandle,
            sellerId_by_user,
            discount_amount,
            bankDetails,
            sale_date,
          } = response.data.data;
          setValue("total_amount", total_amount);
          setValue("discount_amount", discount_amount);
          setValue("note_for_issue", note_for_issue);
          setValue("buyerName", buyerName);
          setValue("buyerInstaHandle", buyerInstaHandle);
          setValue("sellerId_by_user", sellerId_by_user);
          setValue("ifscCode", bankDetails?.ifscCode);
          setValue("bankName", bankDetails?.bankName);
          setValue("accountHolderName", bankDetails?.accountHolderName);
          setValue("accountNumber", bankDetails?.accountNumber);
          setValue(
            "sale_date",
            moment(sale_date, "YYYY-MM-DD").format("YYYY-MM-DD")
          );
          setUpiProductList({
            UPICodeList: UPICode,
          });
          setUpiProduct({ UPICode: "" });
        }
      } catch (error) {
        // Toast({ type: "error", message: error.data.message });
      }
    }
  };

  // isEdit
  const onSubmit = async (data) => {
    let body;
    if (upiProductList?.UPICodeList.length) {
      body = {
        ...data,
        UPICode: upiProductList.UPICodeList,
      };
    } else {
      body = {
        ...data,
        UPICode: [],
        // bankDetails: {
        //   accountHolderName: data.accountHolderName,
        //   bankName: data.bankName,
        //   accountNumber: data.accountNumber,
        //   ifscCode: data.ifscCode,
        // },
      };

      if (
        data.accountHolderName &&
        data.bankName &&
        data.accountNumber &&
        data.ifscCode
      ) {
        body.bankDetails = {
          accountHolderName: data.accountHolderName,
          bankName: data.bankName,
          accountNumber: data.accountNumber,
          ifscCode: data.ifscCode,
        };
      }
    }
    // if (data.bankDetails) {
    //   body.bankDetails = {
    //     accountHolderName: data.bankHolderName,
    //     bankName: data.bankName,
    //     accountNumber: data.accountNumber,
    //     ifscCode: data.ifscCode,
    //   };
    // }

    if (editModal) {
      if (UPICode.length>0) {
        Toast({ type: "error", message: "Please add UPI ID before saving"});
      } else {
        body.buyerId = id;
        console.log(UPICode, "UPICode");
        try {
          let response = await updateDispute(body);

          if (response) {
            Toast({ type: "success", message: response.data.message });
            handleCancel();
            getDisputed();
          }
        } catch (error) {
          Toast({ type: "error", message: error.data.message });
        }
      }
    } else {
      try {
        if (validation !== "Seller already exist") {
          let response = await addDispute(body);
          if (response.status == 200) {
            handleCancel();
            Toast({ type: "success", message: response.data.message });
            getDisputed();
          }
        }
      } catch (error) {
        Toast({ type: "error", message: error.data.message });
      }
    }
  };

  const resetFormDetails = () => {
    setValue("total_amount", "");
    setValue("note_for_issue", "");
    setValue("discount_amount", "");
    setValue("buyerName", "");
    setValue("buyerInstaHandle", "");
    setValue("sale_date", "");
    setValue("sellerId_by_user", "");
    setValue("ifscCode", "");
    setValue("bankName", "");
    setValue("accountNumber", "");
    setValue("accountHolderName", "");
    setUpiProductList({ UPICodeList: [] });
    setUpiProduct({ UPICode: "" });
    clearErrors("total_amount");
    clearErrors("note_for_issue");
    clearErrors("discount_amount");
    clearErrors("buyerName");
    clearErrors("buyerInstaHandle");
    clearErrors("sale_date");
    clearErrors("sellerId_by_user");
    clearErrors("ifscCode");
    clearErrors("bankName");
    clearErrors("accountNumber");
    clearErrors("accountHolderName");
  };

  const deleteList = (val, listName) => {
    let dataList = upiProductList;
    dataList[listName] = dataList[listName].filter((x) => x !== val);
    setUpiProductList({ ...dataList });
  };

  const handleChange = ({ name, value }) => {
    setUpiProduct({
      [name]: value,
    });
  };

  const addListOfRecords = (name) => {
    let UPIValidation = /^[\w.-]+@[\w.-]+$/.test(upiProduct[name]);
    let dataList = upiProductList;
    console.log(dataList, "datadwr");
    let findDuplicate = dataList[name + "List"].indexOf(upiProduct[name]);
    if (findDuplicate === -1) {
      if (name === "UPICode" && UPIValidation) {
        dataList[name + "List"].push({ upi: upiProduct.UPICode });
        setUpiProductList({ ...dataList });
        setUpiProduct({
          [name]: "",
        });
        setValue(name, "");
      }
      // if(sellerProduct.length > 0){
      if (name === "sellerProduct" && !!upiProduct[name]) {
        if (/^[a-zA-Z][\sa-zA-Z]*/.test(upiProduct[name])) {
          if (/^[a-zA-Z ]*$/.test(upiProduct[name])) {
            dataList[name + "List"].push(upiProduct[name]);
            setUpiProductList({ ...dataList });
            setUpiProduct({
              [name]: "",
            });
            setValue(name, "");
          } else {
            Toast({
              type: "error",
              message: "Product name should contain only letters",
            });
          }
        } else {
          Toast({
            type: "error",
            message: "Product name should start with alphabets",
          });
        }
      }
    } else {
      Toast({ type: "error", message: "Already exists" });
    }
    if (!UPIValidation && name === "UPICode" && upiProduct[name] !== "") {
      Toast({ type: "error", message: "Please enter valid UPI ID" });
    }
  };

  const { UPICodeList } = upiProductList;
  const { UPICode } = upiProduct;

  const ifscCode = watch("ifscCode");
  const bankName = watch("bankName");
  const accountNumber = watch("accountNumber");
  const accountHolderName = watch("accountHolderName");

  const isUPIEntered = UPICodeList?.filter((items) => items !== "");

  const isBankDetailEntered = [
    ifscCode,
    bankName,
    accountNumber,
    accountHolderName,
  ].some((data) => !!data);

  return (
    <>
      {!viewPage && isOperationAvailable("Add Dispute") && (
        <AddButton label="ADD Dispute" onClick={showModalFunc} />
      )}

      <Popup isOpen={showModal} setPopup={handleCancel}>
        <div className={styles.dispute_product_form}>
          <div className={styles.dispute_form_title}>
            <span>{`${editModal ? "EDIT" : "ADD"} DISPUTE`}</span>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Seller ID *"
                type="number"
                placeholder="Seller Id"
                register={register("sellerId_by_user", {
                  required: true,
                })}
                onChange={debounce(validateSellerUsingAPI, 1000)}
                error={errors.sellerId_by_user}
              />
              <ErrorMessage
                error={errors.sellerId_by_user}
                message={{
                  required: "Please enter seller ID",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Sell Date *"
                register={register("sale_date", { required: true })}
                error={errors.sale_date}
                max={new Date().toISOString().split("T")[0]}
                // value={String(inventory?.sale_date).substr(0, 10)}
                type="date"
                onkeydown={(e) => e.preventDefault()}
              />
              <ErrorMessage
                error={errors.sale_date}
                message={{ required: "Please enter sell Date" }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Buyer Name *"
                placeholder="Name of Buyer"
                register={register("buyerName", {
                  required: true,
                  pattern: /^[a-zA-Z ]+$/,
                  maxLength: 50,
                })}
                error={errors.buyerName}
                type="text"
              />
              <ErrorMessage
                error={errors.buyerName}
                message={{
                  required: "Please enter buyer name",
                  pattern: "Please enter text only",
                  maxLength:
                    "Buyer Name should not be greater than 50 characters",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Buyer Insta Handle *"
                placeholder="Buyer Insta Handle"
                register={register("buyerInstaHandle", {
                  required: true,
                  pattern:
                    /^(?:@|(?:https?:\/\/)?(?:www\.)?instagr(?:\.am|am\.com)\/)?(\w+)\/?$/,
                  maxLength: 100,
                })}
                error={errors.buyerInstaHandle}
                type="text"
              />
              <ErrorMessage
                error={errors.buyerInstaHandle}
                message={{
                  required: "Please enter Buyer Insta Handle",
                  pattern: "Please enter valid Buyer Insta Handle",
                  maxLength:
                    "Buyer Insta Handle should not be greater than 100 characters",
                }}
              />
            </div>

            <div className="col-md-6 mb-4">
              <NormalInput
                label="Total Amount *"
                placeholder="Enter here"
                register={register("total_amount", {
                  required: true,
                  pattern: /^[1-9][0-9]*$/,
                })}
                error={errors.total_amount}
                type="number"
              />
              <ErrorMessage
                error={errors.total_amount}
                message={{
                  required: "Please enter total amount",
                  pattern: "Amount should greater than 0",
                }}
              />
            </div>

            <div className="col-md-6 mb-4">
              <NormalInput
                label="Discount Amount"
                placeholder="Enter here"
                register={register("discount_amount", {
                  required: true,
                  pattern: /^[1-9][0-9]*$/,
                })}
                type="number"
              />
            </div>

            <div className="col-md-6">
              <NormalInput
                label="Seller UPI ID"
                placeholder="Enter UPI ID"
                register={register("UPICode", {
                  // required:isUPIEntered.length == 0 ? true : false,
                  required: false,
                })}
                error={errors.UPICode}
                onChange={handleChange}
                value={UPICode}
                readOnly={isBankDetailEntered}
              />
              <ErrorMessage
                error={errors.UPICode}
                message={{
                  required: "Please enter seller UPI ID",
                }}
              />
            </div>
            <div className="col-md-6 d-flex align-items-end">
              <button
                className={styles.addButton}
                onClick={() => addListOfRecords("UPICode")}
              >
                ADD
              </button>
            </div>
            {UPICodeList.length > 0 && (
              <div className="col-md-12 d-flex flex-wrap">
                {UPICodeList.map((val) => {
                  return (
                    <>
                      {val !== "" && (
                        <div className={styles.list_card_dispute}>
                          {val.upi}
                          <img
                            src={close_icon}
                            alt="Close Icon"
                            onClick={() => deleteList(val, "UPICodeList")}
                          />
                        </div>
                      )}{" "}
                    </>
                  );
                })}
              </div>
            )}
            <div className="col-md-6 mb-4 mt-4">
              <NormalInput
                label="Account Number"
                placeholder="Bank Account Number"
                register={register("accountNumber", {
                  // required: isUPIEntered.length > 0 ? false : true,
                  required: false,

                  maxLength: 20,
                  minLength: 12,
                })}
                type="number"
                readOnly={isUPIEntered.length > 0}
                value={accountNumber}
                error={errors.accountNumber}
              />
              <ErrorMessage
                error={errors.accountNumber}
                message={{
                  required: "Please enter Account Number ",
                  maxLength:
                    "Account Number should not be greater than 20 characters",
                  minLength:
                    "Account Number must not be lesser than 12 characters",
                }}
              />
            </div>
            <div className="col-md-6 mb-4 mt-4">
              <NormalInput
                label="Account Holder Name"
                placeholder="Bank Account Holder Name"
                register={register("accountHolderName", {
                  // required: isUPIEntered.length > 0 ? false : true,
                  required: false,

                  pattern: /^[a-zA-Z ]+$/,
                })}
                readOnly={isUPIEntered.length > 0}
                value={accountHolderName}
                error={errors.accountHolderName}
              />
              <ErrorMessage
                error={errors.accountHolderName}
                message={{
                  required: "Please enter Account Holder Name",
                  pattern: "Please enter text only",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Bank Name"
                placeholder="Bank Name"
                register={register("bankName", {
                  // required: isUPIEntered.length > 0 ? false : true,
                  required: false,

                  pattern: /^[a-zA-Z ]+$/,
                })}
                readOnly={isUPIEntered.length > 0}
                error={errors.bankName}
                value={bankName}
              />
              <ErrorMessage
                error={errors.bankName}
                message={{
                  required: "Please enter Bank Name ",
                  pattern: "Please enter text only",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="IFSC Code"
                placeholder="IFSC code"
                register={register("ifscCode", {
                  // required: isUPIEntered.length > 0 ? false : true,
                  required: false,
                  pattern: /^[a-zA-Z0-9 ]+$/,
                  maxLength: 12,
                  minLength: 8,
                })}
                readOnly={isUPIEntered.length > 0}
                error={errors.ifscCode}
                value={ifscCode}
              />
              <ErrorMessage
                error={errors.ifscCode}
                message={{
                  required: "Please enter IFSC code ",
                  pattern: "Please enter Valid IFSC Code",
                  maxLength:
                    "IFSC code should not be greater than 12 characters",
                  minLength: "IFSC code should not be lesser than 8 characters",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Notes *"
                placeholder="Notes"
                register={register("note_for_issue", {
                  required: true,
                  pattern: /^[a-zA-Z ]+$/,
                })}
                error={errors.note_for_issue}
                type="text"
              />
              <ErrorMessage
                error={errors.note_for_issue}
                message={{
                  required: "Please enter note",
                  pattern: "Please enter  text only",
                }}
              />
            </div>
          </div>
        </div>
        <SaveCancelBtn
          position="center"
          onCancel={() => handleCancel()}
          onSave={handleSubmit(onSubmit)}
        />
        {successPopUp()}
      </Popup>
    </>
  );
};

export default AddDispute;
